export const NAME = 'services';
export const SERVICE_FORM_NAME = 'service-form';
